import { ReactElement } from "react"

import AmendEVACDeviceForm from "../../../../components/devices/lct/evac/amendEVACDeviceForm"
import NewEVACDeviceAmendmentProvider from "../../../../components/devices/lct/evac/providers/newEVACDeviceAmendmentProvider"

const AmendEVACDevice = (): ReactElement => (
    <NewEVACDeviceAmendmentProvider>
        <AmendEVACDeviceForm />
    </NewEVACDeviceAmendmentProvider>
)

export default AmendEVACDevice
